const { accountNo } = require('./account-no')
const { iban } = require('./iban')
const { phone } = require('./phone')
const { postalCode } = require('./postal-code')
const { ssn } = require('./ssn')

module.exports = {
  accountNo,
  iban,
  phone,
  postalCode,
  ssn
}
